import type React from "react";
import "../styles/LoginForm.css";

type AuthorizationCardProps = {
  onAuthorize: () => void;
  appName?: string;
  isLoading: boolean;
};

const AuthorizationCard: React.FC<AuthorizationCardProps> = ({
  onAuthorize,
  appName,
  isLoading,
}) => {
  return (
    <div className="card">
      <h2 className="title">Authorization request</h2>
      <p className="cardDescription">
        <strong>{appName}</strong> is requesting permission to access your account.
      </p>
      <button
        style={{
          marginTop: "10px",
        }}
        className="loginBtn"
        onClick={onAuthorize}
        disabled={isLoading}
      >
        {isLoading && <span className="loadingSpinner"></span>}
        Authorize
      </button>
    </div>
  );
};

export default AuthorizationCard;
